import React, {Component} from 'react';
import PropTypes from 'prop-types'
import _ from 'lodash';
import {sharedLabelsPath} from "../../../reducers/common/localization";

class LabelWithPages extends Component {
    constructor(props) {
        super(props);

        this.state = {
            total: null
        }
    }

    componentWillMount() {
        if (!_.isNull(this.props.total)) {
            this.setState({total: this.props.total});
        }
    }

    componentWillUpdate(nextProps) {
        if (nextProps.total !== this.props.total && !_.isNull(nextProps.total)) {
            this.setState({total: nextProps.total});
        }
    }

    render() {
        return (
            <h4 className='page-label'>
                {this.props.label + ' '}
                ({
                    _.get(this.props.translation, sharedLabelsPath.pages_label)
                        .replace('{currentNumber}', this.props.currentIndex + 1)
                        .replace('{totalNumber}', this.state.total || (this.props.left + this.props.processed) || '')
                })
            </h4>
        );
    }
}

LabelWithPages.propTypes = {
    left: PropTypes.number,
    total: PropTypes.number,
    processed: PropTypes.number,
    currentIndex: PropTypes.number,
    label: PropTypes.string,
    translation: PropTypes.object
};

export default LabelWithPages;



// WEBPACK FOOTER //
// ./src/components/commonComponents/labelWithPages/LabelWithPages.js